import { Route, Routes } from 'react-router-dom';

import { Error404PageWithTranslations } from '@components/Error/Error404PageWithTranslations';
import { useSetPageBackground } from '@components/Layouts/usePageBackground';
import { customerRoutes } from 'noddi-util';
import { TireOffer } from './TireOffer';
import { TireOfferAddress } from './TireOffer/Address';
import { TireOfferConfirmationWithPaymentLeft } from './TireOffer/ConfirmationWithPaymentLeft';
import { InvoicedOrderConfirmed } from './TireOffer/InvoicedOrderConfirmed';
import { TireOfferLogin } from './TireOffer/Login';
import { TireOfferOrderConfirmed } from './TireOffer/PaymentOrderConfirmed';
import { TireSelection } from './TireOffer/Selection';
import { TireOfferSummary } from './TireOffer/Summary';

export function TireOfferRouter() {
  // Set once for the whole flow, so loading screens and steps without a content wrapper keep it between steps.
  useSetPageBackground('grouped');

  return (
    <Routes>
      <Route path={customerRoutes.tireOfferInfo.getBasePath()} element={<TireOffer />} />
      <Route path={customerRoutes.tireOfferSelection.getBasePath()} element={<TireSelection />} />
      <Route path={customerRoutes.tireOfferAddress.getBasePath()} element={<TireOfferAddress />} />
      <Route path={customerRoutes.tireOfferLogin.getBasePath()} element={<TireOfferLogin />} />
      <Route path={customerRoutes.tireOfferSummary.getBasePath()} element={<TireOfferSummary />} />
      <Route
        path={customerRoutes.tireOfferConfirmation.getBasePath()}
        element={<TireOfferConfirmationWithPaymentLeft />}
      />
      <Route path={customerRoutes.tireOfferPaymentInfo.getBasePath()} element={<TireOfferOrderConfirmed />} />
      <Route path={customerRoutes.tireOfferInvoicedOrderConfirmed.getBasePath()} element={<InvoicedOrderConfirmed />} />
      <Route path='*' element={<Error404PageWithTranslations />} />
    </Routes>
  );
}
